import React from "react";
import "./App.css"
import {
  createBrowserRouter,
  Outlet, 
  useNavigate,
  Navigate
} from "react-router-dom";

import Color from "./Components/Colors/Color";

import Home from "./Sections/Home";
import Navbar from "./Components/Navbar/Navbar";
import Products from "./Pages/ProductsPage";
import Footer from "./Components/Footer/Footer";
import Landing from "./Pages/Landing";
import { StateProvider } from "./Contexts/productsCardContext"
import { NavbarStateProvider } from "./Contexts/NavbarContect";
import ProductDetails from "./Pages/ProductsDetails";
import Service from "./Pages/Service";
import PageNotFound from "./Pages/NotFound";
import LoginPage from "./Admin/Pages/LoginPage";
import ForgotPassPage from "./Admin/Pages/ForgotPassPage";
import ResetPassword from "./Admin/Pages/ResetPassword";
import AdminHome from "./Admin/Pages/AdminHome";
import AdminNav from "./Admin/Components/Navbar/AdminNav";
import AdminProductDetail from "./Admin/Pages/AdminProductDetail";
import AdminAnnouncement from "./Admin/Pages/AdminAnnouncement";
import AdminAddProduct from "./Admin/Pages/AdminAddProduct";
import AdminAnnouncementDetail from "./Admin/Pages/AdminAnnouncementDetail";
import AdminAddAnnouncement from "./Admin/Pages/AdminAddAnnouncement";
import AdminProfilePage from "./Admin/Pages/AdminProfilePage";
import AdminChangePassword from "./Admin/Pages/AdminChangePassword";
import { LogOutStateProvider, useLogOutStateContext } from "./Contexts/LogOutContext";
import LogOut from "./Admin/Components/LogOut/LogOut";
import { jwtDecode } from "jwt-decode";


const AuthGuard = () => {
  const navigate = useNavigate();
  const isAuthenticated = localStorage.getItem("authToken");
  
  if (!isAuthenticated) {
    navigate("/admin");
    return <Navigate to="admin"/>;
  } else{
    let decodedToken = jwtDecode(isAuthenticated);
    if (decodedToken && decodedToken.exp * 1000 < Date.now()){
      navigate("/admin");
      return <Navigate to="admin"/>;
    }
  }

  return <LogOutStateProvider><AdminLayout /></LogOutStateProvider> 
}

const AdminLayout = () => {
  const {showOverlayLogOut} = useLogOutStateContext();

  return(
    <>
      <AdminNav />
      <StateProvider><Outlet /></StateProvider> 
      {showOverlayLogOut.overlay&&(
          <LogOut />
        )}
    </>
    
  )
}

const AppLayout = () => {
  return(
    <div className="app-container" style={{backgroundColor: Color.primaryBackground}}>
      <NavbarStateProvider><StateProvider><Navbar /></StateProvider> </NavbarStateProvider> 
        <Outlet />
      <StateProvider><Footer /></StateProvider>
    </div>
  )
}

const router = createBrowserRouter([
  {
    path: "",
    element: <AppLayout />,
    children: [
      {
        path: "",
        element: <NavbarStateProvider><StateProvider><Landing /></StateProvider> </NavbarStateProvider> 
      }
    ]
  },
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        path: "products",
        children: [
          {
            path: "",
            element: <NavbarStateProvider><StateProvider><Products /></StateProvider></NavbarStateProvider>
          },
          {
            path: "detail",
            element: <NavbarStateProvider><StateProvider><ProductDetails /></StateProvider></NavbarStateProvider> 
          }
        ] 
      },
      {
        path: "services",
        element: <NavbarStateProvider><StateProvider><Service /></StateProvider></NavbarStateProvider> 
      }
    ]
  },
  {
    path: "admin",
    children: [
      {
        path: "",
        element: <LoginPage />
      },
      {
        path: "forgot-password",
        children: [
          {
            path: "",
            element: <ForgotPassPage />
          },
          {
            path: "reset-password",
            element: <ResetPassword />
          }
        ]
      }
    ]
  },
  {
    path: "/",
    element: <AuthGuard />,
    children: [
    {
      path: "admin-dashboard",
      children: [
        {
          path: "",
          element: <AdminHome />,
        },
        {
          path: "product-details",
          element: <AdminProductDetail />
        },
        {
          path: "new-product",
          element: <AdminAddProduct />
        },
        {
          path: "announcements",
          children: [
            {
              path: "",
              element: <AdminAnnouncement />
            },
            {
              path: "new-announcement",
              element: <AdminAddAnnouncement />
            },
            {
              path: "details",
              element: <AdminAnnouncementDetail />
            }
          ]
        },
        {
          path: 'profile',
          children: [
            {
              path: "",
              element: <AdminProfilePage />
            },
            {
              path: "change-password",
              element: <AdminChangePassword />
            }
          ]
        }
      ]
    }
    ]
  },
  {
    path: "*",
    element: <NavbarStateProvider><StateProvider><PageNotFound /></StateProvider> </NavbarStateProvider>
  }
])

export default AppLayout;
export {router};
